import script from "./QuickReceivingDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickReceivingDialog.vue?vue&type=script&setup=true&lang=js"

import "./QuickReceivingDialog.vue?vue&type=style&index=0&id=4c5a8c8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c5a8c8d"]])

export default __exports__